import React, { Component } from 'react';
import { Modal, message, Radio, DatePicker, Button, Upload, InputNumber, Input } from 'antd';
import $, { xToken } from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import SearchRetrieve from '../../common/SearchRetrieve.new';
import ExportUtil from '../../../common/ExportUtil';
import UserDetail from '../../investigation/UserDetail';
import moment from 'moment';

const RadioGroup = Radio.Group;

class RegisterGp extends Component {
    state = {
        params: {},
        nativeFileList: [], //原生file
        visible: false,
        loading: false,
        isEdit: false,
    }

    show = (record = {}) => {
        const { evaluateRecordId, evaluateCode } = record;
        this.setState({
            params: {
                evaluateRecordId,
                evaluateCode,
            },
            visible: true,
        }, () => {
            this.queryGp();
        });
    }

    queryGp = () => {
        const { params: { evaluateCode } } = this.state;
        if (!evaluateCode) {
            return
        }
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryGp,
            data: {
                evaluateCode
            },
            dataType: 'json',
            doneResult: res => {
                const { evaluateRecordAwardGp } = res;
                const {
                    awardDate,
                    gpValue,
                    remark,
                    id,
                    ossFileList,
                } = evaluateRecordAwardGp || {};

                const { params } = this.state;
                (ossFileList || []).map(el => {
                    this.downloadGp(el.id, el.fileName);
                });
                this.setState({
                    params: {
                        ...params,
                        awardDate: awardDate ? moment(awardDate).format('YYYY-MM-DD') : undefined,
                        gpValue,
                        remark,
                        id,
                        ossFileList: ossFileList || [],
                    }
                })
            }
        };
        $.sendRequest(options);
    }

    downloadGp = (id, filename) => {
        if (!id) {
            return
        }
        const options = {
            method: 'POST',
            url: API_URL.evaluate.downloadGp,
            data: {
                fileId: id,
            },
            dataType: 'json',
            doneResult: res => {
                const { fileStr } = res;
                this.base64ToFile(fileStr, id, filename);
            }
        };
        $.sendRequest(options);
    }

    base64ToFile = async (base64String = '', id, filename) => {
        // 如果 base64 字符串包含 data URL 前缀，先提取纯 base64 部分
        let base64Content = base64String;

        // 如果包含 data URL 前缀，如 "data:image/png;base64,"
        if (base64String.includes('base64,')) {
            base64Content = base64String.split('base64,')[1];
        }

        try {
            // 1. 将 base64 字符串转换为二进制数据
            const response = await fetch(`data:${'application/octet-stream'};base64,${base64Content}`);

            // 2. 获取 blob 对象
            const blob = await response.blob();

            // 3. 创建 File 对象
            const file = new File([blob], filename, {
                type: 'application/octet-stream',
                lastModified: Date.now()
            });
            file.uid = id;
            const { nativeFileList } = this.state;
            this.setState({
                nativeFileList: [
                    ...nativeFileList,
                    file,
                ]
            });
        } catch (error) {
            console.error('转换失败:', error);
            throw error;
        }
    }

    hide = () => {
        this.setState({
            params: {},
            visible: false,
            loading: false,
            isEdit: false,
            nativeFileList: [],
        });
    }

    handleChange = (value, key) => {
        const { params } = this.state;
        params[key] = value;
        this.setState({ params });
    }

    beforeUpload = (file) => {
        const { nativeFileList } = this.state;
        const isLt50M = file.size / 1024 / 1024 <= 50;
        if (nativeFileList.length >= 10) {
            message.warning('最多上传10个附件');
            return false;
        }
        if (!isLt50M) {
            message.warning('文件大小不能超过50M');
            return false;
        }
        this.setState({
            nativeFileList: [
                ...nativeFileList,
                file,
            ]
        })
        return false
    }

    handleRemove = (file) => {
        const { nativeFileList } = this.state;
        const index = nativeFileList.indexOf(file);
        const newNativeFileList = nativeFileList.slice();
        newNativeFileList.splice(index, 1);
        this.setState({ nativeFileList: newNativeFileList });
    }

    downLoadFile = (fileMetaId) => {
        const url = API_URL.contract.downloadJdeCodeEnclosure;
        ExportUtil.export({ fileMetaId }, null, url);
    }

    downLoadOssFile = (id) => {
        const url = API_URL.contract.downloadOssFile;
        ExportUtil.export({ id }, null, url);
    }

    submit = () => {
        const { params, nativeFileList } = this.state;
        const { gpValue, remark, awardDate, evaluateCode, id } = params;
        //校验必填
        if (!gpValue) {
            return message.warning('请输入award GP值');
        }
        if (!awardDate) {
            return message.warning('请选择竞标日期');
        }
        const fromData = new FormData();
        (nativeFileList || []).map((file, index) => {
            fromData.append(`files[${index}]`, file)
        });
        fromData.append('curUserId', sessionStorage.userId);
        fromData.append('curRoleCode', sessionStorage.curRole);
        fromData.append('curEmployeeCode', sessionStorage.curEmployeeCode || '');

        fromData.append('evaluateCode', evaluateCode);
        fromData.append('gpValue', gpValue);
        !!remark && fromData.append('remark', remark);
        fromData.append('awardDate', awardDate);
        if (id) fromData.append('id', id);
        this.setState({ loading: true });
        //id有值，说明是修改，不是添加
        const url = id ? API_URL.evaluate.updateGp : API_URL.evaluate.awardGp;
        fetch(url, {
            method: 'post',
            body: fromData,
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                ...xToken,
            }
        }).then(res => {
            if (res.ok) {
                return res.json();
            }
        }).then(data => {
            if (data.error) {
                message.error(data.error);
                this.setState({ loading: false });
            } else {
                message.success(data.success);
                this.hide();
                this.props.loadData();
            }
        }).catch(err => {
            message.error(err);
            this.setState({ loading: false });
        });
    }

    edit = (value) => {
        const { params, params: { awardDate } } = this.state;
        params.awardDate = awardDate ? awardDate : moment().format('YYYY-MM-DD');
        this.setState({ isEdit: value });
    }

    render() {
        const { visible, params, loading, isEdit, nativeFileList } = this.state;
        const { awardDate, ossFileList = [], gpValue, remark } = params;
        const asterisk = <span style={{ color: 'red' }}>*</span>;
        return (
            <Modal
                title={'登记award GP'}
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                maskClosable={false}
                confirmLoading={loading}
                width="450px"
                footer={isEdit ? <span>
                    <Button style={{ maginRight: 10 }} onClick={() => this.edit(false)}>取消</Button>
                    <Button type="primary" onClick={this.submit}>确定</Button>
                </span>
                    : <Button type="primary" onClick={() => this.edit(true)}>编辑</Button>
                }
            >
                <div className="modal-content" style={{ padding: '10px 30px' }}>
                    <ul className="modal-list">
                        <li className="modal-item">
                            <div className="item-left" style={{ width: '40%' }}>{asterisk}award GP：</div>
                            <div className="item-right" style={{ width: '60%' }}>
                                {isEdit ?
                                    <InputNumber
                                        max={100}
                                        value={gpValue}
                                        precision={2}
                                        placeholder="请输入award GP值"
                                        style={{ width: 150, marginRight: 10 }}
                                        onChange={(value) => this.handleChange(value, 'gpValue')}
                                    >
                                    </InputNumber> : gpValue
                                }
                                {!!gpValue && <span>%</span>}
                            </div>
                        </li>
                        <li className="modal-item">
                            <div className="item-left" style={{ width: '40%' }}>{asterisk}award GP登记日期：</div>
                            <div className="item-right" style={{ width: '60%' }}>
                                {isEdit ?
                                    <DatePicker
                                        format={'YYYY-MM-DD'}
                                        value={awardDate ? moment(awardDate) : null}
                                        style={{ width: 180 }}
                                        allowClear={true}
                                        placeholder="请选择award GP登记日期"
                                        onChange={(date, dateString) => this.handleChange(dateString, 'awardDate')}
                                    /> : awardDate
                                }
                            </div>
                        </li>
                        <li className="modal-item">
                            <div className="item-left" style={{ width: '40%' }}>参考附件：</div>
                            <div className="item-right" style={{ width: '60%' }}>
                                {
                                    isEdit ?
                                        <Upload
                                            data={{
                                                curUserId: sessionStorage.userId,
                                                curEmployeeCode: sessionStorage.curEmployeeCode || '',
                                            }}
                                            fileList={nativeFileList}
                                            beforeUpload={this.beforeUpload}
                                            onRemove={this.handleRemove}
                                            headers={xToken}
                                        >
                                            <Button style={{ width: 80 }}>选择文件</Button>
                                        </Upload>
                                        :
                                        (ossFileList || []).map(el => <a onClick={() => this.downLoadOssFile(el.id)}>{el.fileName}<br /></a>)
                                }
                            </div>
                        </li>
                        <li className="modal-item">
                            <div className="item-left" style={{ width: '40%' }}>备注：</div>
                            <div className="item-right" style={{ width: '60%' }}>
                                {isEdit ?
                                    <Input.TextArea
                                        rows={4}
                                        value={remark}
                                        placeholder="请输入备注"
                                        style={{ width: 180, marginRight: 10 }}
                                        onChange={(e) => this.handleChange(e.target.value, 'remark')}
                                    >
                                    </Input.TextArea> : remark
                                }
                            </div>
                        </li>
                    </ul>
                </div>
            </Modal>
        );
    }
}

export default RegisterGp;


// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/RegisterGp.js